export const SIDEBAR_DIMENSIONS = {
    OPEN_WIDTH: '258px',
    CLOSED_WIDTH: '85px',
    ICON_MIN_WIDTH_OPEN: '25px',
    ICON_MIN_WIDTH_CLOSED: '56px',
    MARGIN_LEFT: '15px',
    TEXT_MARGIN_LEFT: '6px',
} as const;